// assets/js/form.js
export function initCf7MessageCounter({
  textareaSelector = '#cf-message',
  counterSelector  = '#cf-message-counter',
  warnRatio = 0.9,
  warnClass = 'text-orange-600',
} = {}) {
  const textarea = document.querySelector(textareaSelector);
  const counter  = document.querySelector(counterSelector);

  if (!textarea || !counter) return;

  const maxAttr = textarea.getAttribute('maxlength');
  const max = parseInt(maxAttr || '0', 10) || 0;

  const update = () => {
    const len = textarea.value.length;
    counter.textContent = `${len} / ${max || '∞'} caractères`;

    // Alerte visuelle quand on approche de la limite
    if (max && len >= Math.floor(max * warnRatio)) counter.classList.add(warnClass);
    else counter.classList.remove(warnClass);
  };

  textarea.addEventListener('input', update);
  update();
}
